<template>
  <div class="crumbs">
    <div class="content-wrap flex flex-between">
      <div class="text-gray">
        当前位置：
        <!-- 仅显示任务名称 -->
        <template v-if="props.type === 'taskOnly'">
          <span class="crumbs-item current task-name" :title="getTaskName()">{{ getTaskName() }}</span>
        </template>

        <!-- 路由嵌套模式（带或不带任务名） -->
        <template v-else>
          <template v-for="(item, index) in props.crumbs" :key="index">
            <template v-if="index != props.crumbs.length - 1 && item.meta?.title">
              <router-link class="crumbs-item" :to="handleToObj(item)">{{ item.meta?.title }}</router-link>
              /
            </template>
            <template v-else>
              <span class="crumbs-item current" v-if="item.meta?.title">{{ item.meta?.title }}</span>
              <!-- 根据type决定是否显示任务名 -->
              <template v-if="shouldShowTaskName()">
                /
                <span class="crumbs-item current">{{ getTaskName() }}</span>
              </template>
            </template>
          </template>
        </template>
      </div>
      <TaskProgress v-if="progress" :current="progress"></TaskProgress>
      <a v-if="help" style="text-decoration: underline" :href="help.link" target="_blank">{{ help.title }}</a>
      <!-- <span v-else class="width120"></span> -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { HistoryState, RouteRecord, useRoute } from "vue-router";
import { computed, ref, watch, type PropType } from "vue";
import TaskProgress from "@/views/task/components/TaskProgress.vue";

// 定义面包屑类型
type CrumbType = 'route' | 'routeWithTask' | 'taskOnly';

const route = useRoute();
const props = defineProps({
  crumbs: {
    type: Object as PropType<RouteRecord[]>,
    default: [] as Array<RouteRecord>,
  },
  type: {
    type: String as PropType<CrumbType>,
    default: 'route' as CrumbType,
    validator: (value: string) => ['route', 'routeWithTask', 'taskOnly'].includes(value)
  },
  taskName: {
    type: String,
    default: ''
  }
});

const help = computed(() => {
  if (route.meta && route.meta.help) {
    return route.meta.help as { link: string, title: string };
  }
  return false;
});

const progress = computed(() => {
  if (route.meta && route.meta.progress) {
    return route.meta.progress as number;
  }
  return false;
})

const _history = ref(history.state) // 保存历史记录

const updateHistoryState = () => {
  console.log('???', history.state);
  _history.value = history.state;
};

// 获取任务名称
const getTaskName = (): string => {
  // 优先使用传入的taskName，其次使用history中的taskName
  if (props.taskName) {
    return props.taskName;
  }
  if (_history.value?.taskName) {
    return decodeURIComponent(_history.value.taskName);
  }
  if (route.params && route.params.taskName) {
    return decodeURIComponent(route.params.taskName as string);
  }
  return '';
};

// 判断是否应该显示任务名
const shouldShowTaskName = (): boolean => {
  const taskName = getTaskName();

  switch (props.type) {
    case 'route':
      return false;
    case 'routeWithTask':
      return !!taskName && !progress.value;
    case 'taskOnly':
      return true;
    default:
      return false;
  }
};

const handleToObj = (item: RouteRecord): HistoryState => {
  if (item.path.match(/:\w+/)) {
    return { name: item.name as string, params: route.params, state: _history.value };
  } else {
    return { name: item.name as string };
  }
};

watch(
  () => route.fullPath,
  () => {
    updateHistoryState();
  }
);
</script>

<style lang="scss" scoped>
.task-name {
  display: inline-flex;
  width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}
</style>
